<template>
  <div class="landing-page">
    <h4 v-if="from === 'product-details'" class="main-header" ref="mainHeader">
      <span class="breadcrumb-link" @click="goTo('products')">{{ $t('products') }}</span> &gt;
      <span class="breadcrumb-link" @click="goToProductDetails('info')">{{ this.product.name }}</span> &gt;
      <span class="breadcrumb-link" @click="goToProductDetails('redirection')">{{ $t('scan_destination') }}</span> &gt;
      {{ this.config.name }}
    </h4>
    <v-progress-linear
      v-show="loading"
      indeterminate
      color="primary"
    ></v-progress-linear>
  <iframe id="stc-frame" v-if="loadIframe" frameborder="0" :src="editorUrl" :style="{ height: iframeHeight, maxHeight: iframeHeight }"></iframe>
  </div>
</template>

<script>

import Api from '@/api'
import amplitude from 'amplitude-js'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'LandingPage',
  computed: {
    ...mapGetters(['selectedCampaign', 'scantrustAuthToken', 'landingPages', 'loadingCampaigns', 'campaigns', 'didProductUpdate', 'consumerOptions', 'selectedProduct'])
  },
  data () {
    return {
      messageListener: null,
      loadIframe: true,
      config: {},
      campaign: {},
      loading: true,
      from: null,
      product: null,
      iframeHeight: '100vh',
      editorUrl: ''
    }
  },
  watch: {
    didProductUpdate () {
      if (this.didProductUpdate) {
        if (document.getElementById('stc-frame')) {
          document.getElementById('stc-frame').src = ''
          this.editorUrl = `${Api.editor_url}#/config/${this.config.id}/editor?product=${this.product.id}&campaign=${this.selectedCampaign.id}&token=${this.scantrustAuthToken}`
          setTimeout(() => {
            document.getElementById('stc-frame').src = this.editorUrl
          }, 200)
        }
        this.setProductUpdateStatus(false)
      }
    },
    selectedCampaign (newVal) {
      if (newVal) {
        this.loadIframe = false
        setTimeout(() => {
          this.loadIframe = true
        }, 100)
      }
    },
    consumerOptions (newVal) {
      if (newVal && this.landingPages) {
        if (newVal.stc_config_shared) {
          this.config = this.landingPages.find((config) => {
            return (config.id === newVal.stc_config_shared)
          })
        }
      }
    }
  },
  methods: {

    ...mapMutations({
      setProductUpdateStatus: 'UPDATE_PRODUCT_UPDATE_STATUS'
    }),

    goTo (route) {
      this.$router.push({ name: route })
    },

    goToProductDetails (tab) {
      this.$router.push({ name: `products.${tab}`, params: { id: this.product.id, tab: tab, product: this.product } })
    },

    initEventHandler () {
      const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent'
      const messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message'

      this.messageListener = (e) => {
        if (e.data.type === 'editor.loaded') {
          this.loading = false
        } else if (e.data.type === 'editor.navigation') {
          if (~e.data.hash.indexOf('#')) {
            this.$router.push(e.data.hash.split('#')[1])
          }
        } else if (e.data.type === 'editor.update-redirection') {
          this.$store.dispatch('loadSelectedCampaignConsumerOptions', this.selectedCampaign.id)
        }
      }
      window[eventMethod](messageEvent, this.messageListener)
    },

    updateIframeHeight () {
      this.$nextTick(() => {
        const header = this.$refs.mainHeader
        const headerH = header ? header.offsetHeight : 0
        const viewportH = window.innerHeight || document.documentElement.clientHeight
        this.iframeHeight = `calc(${viewportH}px - ${headerH}px)`
      })
    }
  },
  async created () {
    amplitude.getInstance().logEvent('Landing Page Editor Opened')
    this.from = this.$route.query.from
    if (this.selectedProduct && this.selectedProduct.id === this.$route.query.product) {
      this.product = this.selectedProduct
    }
    // For when we add landing page list page
    // } else {
    //   this.product = await this.$store.dispatch('loadProduct', this.$route.query.product)
    // }
    this.config = await this.$store.dispatch('loadLandingPage', { id: this.$route.params.id })
    this.editorUrl = `${Api.editor_url}#/config/${this.config.id}/editor?product=${this.product.id}&campaign=${this.selectedCampaign.id}&token=${this.scantrustAuthToken}`
    this.initEventHandler()
    this.updateIframeHeight()
    window.addEventListener('resize', this.updateIframeHeight)
  },
  beforeDestroy () {
    const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent'
    const messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message'

    window.removeEventListener(messageEvent, this.messageListener)
    window.removeEventListener('resize', this.updateIframeHeight)
  }
}

</script>

<style lang="sass" scoped>

.landing-page
  font-family: 'Roboto mono'
  height: 100%
  width: 100%

iframe
  overflow: hidden
  width: 100%
  min-width: 100%
  display: block

</style>
